<template>
  <div class=" text-right" :class="!showCommands.length ? '' : 'reportLink'">
    <div v-for="command in showCommands" :key="command.text" class="d-inline">
      <div class="d-inline-block my-2 ml-3">
        <BaseIcon
          v-if="command.icon"
          noninteractive
          size="sm"
          :name="command.icon"
          class="baseIconColor"
        >
        </BaseIcon>
        <b-button
          v-if="command.type === 'button'"
          target="_blank"
          pressed="false"
          variant="info"
          size="sm"
          @click="() => $emit('onCommandEvent', command.event)"
        >
          {{ command.text }}
        </b-button>
        <b-link  v-else :id="command.text"
          :class="command.isdisable ? 'disabledCursor' : ''"
          class=" my-1 ml-1  text-dark"
          @click="() => $emit('onCommandEvent', command.event)"
        >
          {{ command.text }}

        </b-link>
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    commands: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showCommands() {
      return this.commands.filter((comm) => comm.isShow)
    },
  },
}
</script>

<style scoped>
.reportLink {
  padding: 10px;
  background-color: #f1f1f1;
  border-radius: 4px;
  padding-right:60px;
}
.baseIconColor {
  color: #4b868f;
}
</style>
